
export const FREE_NATIONAL_FREIGHT_LABEL = 'Frete grátis'

export function orderHasPillItems(order: any): boolean {
  if (typeof order?.has_pill_items === 'boolean') return order.has_pill_items
  if (typeof order?.summary?.has_pill_items === 'boolean') return order.summary.has_pill_items

  const items = order?.items || []

  return items.some((item: any) => item?.product?.origin === 'pill')
}

export function getNationalFreightValue(order: any): number {
  return parseFloat(order?.national_freight ?? order?.summary?.national_freight ?? 0) || 0
}

function getOrderCep(order: any): string {
  const raw =
    order?.cep ??
    order?.summary?.cep ??
    order?.zipcode ??
    order?.zip_code ??
    order?.address?.cep ??
    order?.shippingAddress?.cep ??
    order?.shipping_address?.cep ??
    ''

  return String(raw).replace(/\D/g, '')
}

export function hasQuotedNationalFreight(order: any): boolean {
  if (!orderHasPillItems(order)) return false

  if (getOrderCep(order).length === 8) return true

  return Boolean(order?.estimated_delivery_pill ?? order?.summary?.estimated_delivery_pill)
}

export function shouldShowNationalFreight(value: number, quoted: boolean): boolean {
  return value > 0 || quoted
}
